import { FC } from "react";

interface SpriteProps {
  filename: string;
  x: number;
  y: number;
  width: number;
  height: number;
  marginX?: number;
  marginY?: number;
  originX?: number;
  originY?: number;
  className?: string;
}

const Sprite: FC<SpriteProps> = ({
  filename,
  x,
  y,
  width,
  height,
  marginX = 0,
  marginY = 0,
  originX = 0,
  originY = 0,
  className,
}) => {
  if (!filename) {
    return null;
  }

  const style = {
    backgroundImage: `url(${filename})`,
    backgroundPosition: `${(width + marginX) * x * -1 - originX}px ${(height + marginY) * y * -1 - originY}px`,
    backgroundRepeat: "no-repeat",
    width,
    height,
    overflow: "none",
  };

  return <div style={style} className={className} />;
};

export default Sprite;
